import axiosInstance from "../utils/axiosInstance";

// ---------- Employee ----------

// `changes` is a flat map of dot-path -> new value, e.g.
// { "bank_info.account_number": "98765432", phone: "9000000000" }
export async function submitChangeRequest(changes) {
  const { data } = await axiosInstance.post("/employee-change-requests", {
    changes,
  });
  return data;
}

export async function fetchMyChangeRequests() {
  const { data } = await axiosInstance.get("/employee-change-requests/mine");
  return data?.data ?? [];
}

export async function cancelChangeRequest(id) {
  const { data } = await axiosInstance.put(
    `/employee-change-requests/${id}/cancel`,
  );
  return data;
}

// ---------- Admin ----------

export async function fetchAllChangeRequests(status) {
  const { data } = await axiosInstance.get("/employee-change-requests", {
    params: status ? { status } : {},
  });
  return data?.data ?? [];
}

// `confirmConflict` re-sends the approval after the admin has acknowledged
// that the live value changed since the request was raised (HTTP 409).
export async function reviewChangeRequest(id, payload) {
  const { data } = await axiosInstance.put(
    `/employee-change-requests/${id}/status`,
    payload,
  );
  return data;
}
